import { HoverPopInline } from '@components/HoverPop';
import { For, Show } from 'solid-js';

import { insuranceProduct } from './LoadSureHelpers';

type LoadSureQuoteProps = {
  /** The product the user selected, so consent is recorded against it. */
  quote: insuranceProduct | null;
};

export const LoadSureExclusionsLink = (props: Readonly<LoadSureQuoteProps>) => (
  <HoverPopInline
    anchor={<div class="text-armstrong-blue underline">Exclusions</div>}
    render={true}
  >
    <div class="text-sm p-4 max-w-150">
      <Show
        fallback={<div>No exclusions</div>}
        when={Boolean(props.quote?.commodityExclusions.length)}
      >
        <div>
          <div class="text-lg font-semibold mb-2">
            List of excluded commodities
          </div>
          <For each={props.quote?.commodityExclusions}>
            {(exclusion) => (
              <div class="capitalize text-sm">
                <span class="font-semibold">•</span> {exclusion}
              </div>
            )}
          </For>
        </div>
      </Show>
    </div>
  </HoverPopInline>
);

type LoadSureTermsLinkProps = LoadSureQuoteProps & {
  label: string;
};

export const LoadSureTermsLink = (props: Readonly<LoadSureTermsLinkProps>) => (
  <a
    href={props.quote?.termsAndConditionsLink}
    target="_blank"
    rel="noopener noreferrer"
    class="text-armstrong-blue underline"
  >
    {props.label}
  </a>
);
